// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomFormikCheckbox_wrapper__K+bwn","error":"CustomFormikCheckbox_error__lZg0+"};